import { render, staticRenderFns } from "./buyerWithdrawAuditDetail.vue?vue&type=template&id=55716cea&"
import script from "./buyerWithdrawAuditDetail.vue?vue&type=script&lang=js&"
export * from "./buyerWithdrawAuditDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports